module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-modal-routing-3/gatsby-browser.js'),
      options: {"plugins":[],"modalProps":{"style":{"overlay":{"zIndex":10},"content":{"padding":0,"inset":"1.125rem","border":"solid 1px","borderRadius":0}}}},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"googleAnalytics":{"trackingId":"G-ST9TY2Z9W8","cookieName":"bengaru-gdpr-google-analytics"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Bengaru","short_name":"Bengaru","start_url":"/","background_color":"#ffffff","theme_color":"#ff4d16","display":"minimal-ui","icon":"src/images/star-tiny-static.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"331019b83693462d00aa273b206980af"},
    },{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/opt/build/repo/src/intl","languages":["es","en"],"defaultLanguage":"es"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
